import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

export const CurrencyDataContext = createContext();
export const useCurrencyData = () => useContext(CurrencyDataContext);

export const CurrencyDataProvider = ({ children }) => {
  const [monhanshData, setMonhanshData] = useState({});
  const [currencyData, setCurrencyData] = useState([]);
  const tugrug = useMemo(() => ({
    code: "MNT",
    last_date: "",
    name: "Монголын төгрөг",
    rate: "1",
    rate_date: "",
    rate_float: 1,
    sortKey: 0,
  }), []);

  const sortCurrency = useCallback((sortedCurrencyList, sortedBaseCurrencyList) => {
    // Create a hash map with no prototype
    const sortKeyMap = sortedBaseCurrencyList.reduce((map, item) => {
      map[item.currencyCode] = item.sortKey;
      return map;
    }, Object.create(null));

    // Iterate over arr1 and assign sortKey
    sortedCurrencyList.forEach((item) => {
      if (item.code in sortKeyMap) {
        item.sortKey = sortKeyMap[item.code];
      }
    });
    sortedCurrencyList = [...sortedCurrencyList, tugrug];
    return sortedCurrencyList.sort((a, b) => a.sortKey - b.sortKey);
  }, [tugrug]);

  // Валютын жагсаалтыг fetch хийх
  const fetchSortedBaseCurrencyList = useCallback(async () => {
    try {
      const response = await fetch("/json/SortedBaseCurrencyList.json");
      if (!response.ok) {
        throw new Error("Failed to fetch currency list");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching currency list:", error);
      return [];
    }
  }, []);

  const fetchCurrencyRate = useCallback(async () => {
    try {
      // Эхлээд валютын жагсаалтыг авах
      const currencyList = await fetchSortedBaseCurrencyList();

      // Дараа нь ханшийн мэдээлэл авах
      const response = await fetch("https://monxansh.appspot.com/xansh.json");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      setMonhanshData(jsonData);

      // Хоёр мэдээллийг нэгтгэж эрэмбэлэх
      const sortedCurrencyData = sortCurrency(jsonData, currencyList);
      setCurrencyData(sortedCurrencyData);
    } catch (error) {
      console.error("Failed to fetch:", error);
    }
  }, [fetchSortedBaseCurrencyList, sortCurrency]);

  useEffect(() => {
    fetchCurrencyRate();
  }, [fetchCurrencyRate]);

  return (
    <CurrencyDataContext.Provider
      value={{ currencyData, fetchCurrencyRate, monhanshData }}
    >
      {children}
    </CurrencyDataContext.Provider>
  );
};
